import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search, X, ChevronUp, ChevronDown } from "lucide-react";

const counterText = (query, total, current) => {
  if (!query) return "Escriba para buscar";
  if (!total) return "Sin coincidencias";
  return `${current + 1} / ${total} coincidencia${total === 1 ? "" : "s"}`;
};

export function HelpSearchBar({ search }) {
  const { query, setQuery, clear, matchCount, currentMatch, jumpToMatch } = search;
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-md border border-slate-200 bg-white p-3 shadow-sm"
      data-testid="help-search-bar">
      <div className="relative flex-1 min-w-[240px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" strokeWidth={1.75} />
        <Input value={query} onChange={(e) => setQuery(e.target.value)}
          placeholder="Buscar en el documento (títulos, tablas, párrafos)..."
          className="pl-9 pr-9 focus-visible:ring-orange-500" data-testid="help-search-input" />
        {query && (
          <button type="button" onClick={clear} aria-label="Limpiar búsqueda" data-testid="help-search-clear"
            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700">
            <X className="w-4 h-4" strokeWidth={1.75} />
          </button>
        )}
      </div>
      <div className="flex items-center gap-2 text-xs text-slate-500" data-testid="help-search-counter">
        {counterText(query, matchCount, currentMatch)}
      </div>
      <div className="flex items-center gap-1">
        <Button type="button" variant="outline" size="icon" className="h-8 w-8" disabled={!matchCount}
          onClick={() => jumpToMatch(currentMatch - 1)} data-testid="help-search-prev" title="Anterior">
          <ChevronUp className="w-4 h-4" strokeWidth={1.75} />
        </Button>
        <Button type="button" variant="outline" size="icon" className="h-8 w-8" disabled={!matchCount}
          onClick={() => jumpToMatch(currentMatch + 1)} data-testid="help-search-next" title="Siguiente">
          <ChevronDown className="w-4 h-4" strokeWidth={1.75} />
        </Button>
      </div>
    </div>
  );
}

export function HelpHeadingHits({ headings, onJump }) {
  if (!headings.length) return null;
  return (
    <div className="rounded-md border border-orange-200 bg-orange-50/60 p-3" data-testid="help-heading-hits">
      <div className="text-[11px] uppercase tracking-wider text-orange-700 font-semibold mb-2">
        Secciones que coinciden ({headings.length})
      </div>
      <div className="flex flex-wrap gap-2">
        {headings.slice(0, 12).map((h) => (
          <button key={h.slug} type="button" onClick={() => onJump(h.slug)}
            className="px-2.5 py-1 rounded border border-orange-300 bg-white text-xs text-orange-800 hover:bg-orange-100 transition-colors"
            data-testid={`help-heading-jump-${h.slug}`}>
            {h.text}
          </button>
        ))}
      </div>
    </div>
  );
}
